import {Action} from '@ngrx/store';
import {FullUser} from '../model';
import {HideLoader, ShowLoader} from '../../loading-indicator/store/decorators';
import {UserToEdit} from './users.reducer';

export const SAVING_USER = 'Saving Settings';
export const SAVED_USER = 'Saved user';
export const SAVE_USER_ERROR =  'User Save Error';
export const LOAD_USER = 'User Load ';
export const LOAD_USER_TO_EDIT = 'User Load To Edit';
export const LOAD_USER_FINISHED = 'User Load Finished';
export const LOAD_USER_TO_EDIT_FINISHED = 'User Load To Edit Finished';
export const LOAD_USER_ERROR = 'User Load Error';
export const UPDATE_USER_TO_EDIT = 'User To Edit Update';
export const SAVE_USER_TO_EDIT = 'User to Edit Save';
export const SAVE_USER_TO_EDIT_FINISHED = 'User To Edit Saved';
export const SEARCH_USER = 'Search User';
export const SEARCH_USER_FINISHED = 'Search User Finished';


@ShowLoader()
export class SavingUser implements  Action {
  readonly  type = SAVING_USER;
  constructor( public payload: {user: FullUser, file: File}) {}
}

@HideLoader(SAVING_USER)
export class SavedUser implements Action {
  readonly type = SAVED_USER;
  constructor(public payload: FullUser) {}
}

@HideLoader(SAVED_USER)
export class SaveUserError implements Action {
  readonly type = SAVE_USER_ERROR;
  constructor( public payload: string) {}
}

@ShowLoader()
export class LoadUser implements Action {
  readonly type = LOAD_USER;

  constructor(public payload: string) {
  }
}

@ShowLoader()
export class LoadUserToEdit implements Action {
  readonly type = LOAD_USER_TO_EDIT;

  constructor(public payload: string) {
  }
}



@HideLoader(LOAD_USER)
export class LoadUserFinished implements Action {
  readonly type = LOAD_USER_FINISHED;
  constructor(public payload: FullUser) {}
}

@HideLoader(LOAD_USER)
export class LoadUserError implements Action {
  readonly type = LOAD_USER_ERROR;
  constructor(public payload: string) {}
}

@HideLoader(LOAD_USER_TO_EDIT)
export class LoadUserToEditFinished implements  Action {
  readonly type = LOAD_USER_TO_EDIT_FINISHED;
  constructor(public payload) {}
}

export class UpdateUserToEdit implements Action {
  readonly  type = UPDATE_USER_TO_EDIT;
  constructor(public payload: UserToEdit) {}
}

@ShowLoader()
export class SaveUserToEdit implements Action {
  readonly type = SAVE_USER_TO_EDIT;
  constructor(public payload: UserToEdit) {};
}

@HideLoader(SAVE_USER_TO_EDIT)
export class SaveUserToEditFinished implements Action {
  readonly type = SAVE_USER_TO_EDIT_FINISHED;
  constructor(public payload: FullUser) {}
}

@ShowLoader()
export class SearchUser implements Action {
  readonly type = SEARCH_USER;
  constructor(public payload: string) {}
}

@HideLoader(SEARCH_USER)
export class SearchUserFinished implements Action {
  readonly type = SEARCH_USER_FINISHED;
  constructor(public payload: FullUser[]) {}
}
export type UserActions = SavingUser
  | SavedUser
  | SaveUserError
  | LoadUser
  | LoadUserFinished
  | LoadUserError
  | LoadUserToEditFinished
  | UpdateUserToEdit
  | SaveUserToEdit
  | SaveUserToEditFinished
  | SearchUser
  | SearchUserFinished;


